import { type CheckboxOptionType } from 'antd';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useCompanyFormats from '../../../../../utilities/useCompanyFormats';
import FilterGroup from '../../../StandardApplicationEntrypoint/CarListingPage/CarFilter/FilterGroup';
import { useCarListingState } from '../CarListingStateProvider';

const DailyRateFilter = () => {
    const { t } = useTranslation(['carList']);
    const {
        state: { filters, rangeVehiclePricesFilter },
        actions,
    } = useCarListingState();

    const { currencySymbol, formatAmount } = useCompanyFormats();

    const options: CheckboxOptionType[] = useMemo(
        () =>
            filters.dailyRates.map(dailyRate => ({
                label: t('carList:filter.dailyRate', {
                    currency: currencySymbol,
                    from: formatAmount(dailyRate.from),
                    to: formatAmount(dailyRate.to),
                }),
                value: `${dailyRate.from}-${dailyRate.to}`,
            })),
        [currencySymbol, filters.dailyRates, formatAmount, t]
    );

    const onChange = useCallback(
        (value: string[]) => {
            actions.setPage(1);
            actions.setScroll(false);
            actions.setRangeVehiclePricesFilter(value);
        },
        [actions]
    );

    if (!options?.length || options.length === 1) {
        return null;
    }

    return (
        <FilterGroup
            onChange={onChange}
            options={options}
            title={t('carList:filter.dailyRateTitle')}
            value={rangeVehiclePricesFilter || []}
        />
    );
};

export default DailyRateFilter;
